import { Button } from '@mui/material';
import { styled } from '@mui/system';

export const LandingTextButton = styled(Button)({
  backgroundColor: 'transparent',
  color: '#30342E',
  fontSize: '18px',
  borderRadius: 0,
  padding: 0,
  borderBottom: '2px solid transparent',
  lineHeight: '2em',
  height: '2em',
  '&:hover': {
    backgroundColor: 'transparent',
    borderBottomColor: '#a9c571',
  },
});

export const LandingPrimaryButton = styled(Button)({
  backgroundColor: '#E9F073',
  color: '#5D7243',
  fontWeight: 'normal',
  fontSize: '18px',
  borderBottom: '2px solid transparent',
  lineHeight: '1em',
  borderRadius: '24px',
  padding: '14px 20px',
  '&:hover': {
    color: '#E9F073',
    backgroundColor: '#5d7243',
  },
});

export const LandingSecondaryButton = styled(LandingPrimaryButton)({
  backgroundColor: '#5D7243',
  color: '#E9F073',
  '&:hover': {
    color: '#E9F073',
    backgroundColor: '#5D6643',
  },
});
